// 📁 constants/moments.js
import { logDev } from "../utils/logger.js";

export const moments = [
  { key: "Matin", labelKey: "Moment_Matin", color: "#f6eac2ff" },
  { key: "Midi", labelKey: "Moment_Midi", color: "#fff3e0" },
  { key: "Soir", labelKey: "Moment_Soir", color: "#e3f2fd" },
];

// Partie séparée pour le custom
export const customMoment = { key: "Custom", color: "#fffdf2" };

export const mapMoment = (val) => {
  if (val === undefined || val === null) return "Custom";
  const str = val.toString().trim().toLowerCase();

  logDev("[moments] mapMoment input normalisé", { val, str });

  if (["0", "08", "matin"].includes(str)) return "Matin";
  if (["1", "12", "midi"].includes(str)) return "Midi";
  if (["2", "21", "soir"].includes(str)) return "Soir";

  // 🔧 Ajout du cas Custom
  if (["3", "custom", "personnalisé", "personnalise"].includes(str)) return "Custom";

  return "Custom"; // fallback par défaut
};

export const getMomentColor = (momentKey) => {
  if (momentKey === "Custom") {
    logDev("[moments] getMomentColor", { momentKey, color: customMoment.color });
    return customMoment.color; // 👈 on renvoie la couleur définie
  }  
  const color = moments.find(m => m.key === momentKey)?.color || "#ccc";
  logDev("[moments] getMomentColor", { momentKey, color });
  return color;
};
